/** Tunable game constants. Kept in one place so balancing never means hunting through code. */
export const CONFIG = {
  /** Game minutes that pass per real second (1 in-game hour = 16s). */
  minutesPerSecond: 3.75,
  wakeMinutes: 8 * 60,
  /** Stay up past this and you pass out wherever you are standing. */
  passOutMinutes: 3 * 60,
  napMinutes: 3 * 60,
  /** Sleeping is only allowed after this hour (otherwise you nap). */
  bedtimeHour: 20,

  rentBase: 150,
  rentHike: 25,
  /** 0 = Monday ... 4 = Friday. */
  rentDayOfWeek: 4,
  rentCheckMinutes: 17 * 60,
  maxStrikes: 3,
  debtInterest: 0.15,

  doubleWidePrice: 2500,
  /** Buying Lucky Acres back from Apex: solo goal, plus this much per extra player in a park. */
  buybackGoal: 15000,
  buybackPerNeighbor: 5000,
  /** Weekly co-op dues once the residents own the park. */
  coopDues: 40,
  canValue: 0.5,
  partPrice: 25,
  camaroPartsNeeded: 5,
  camaroSaleValue: 1200,
  /** Cooter's pre-owned Lil' Rascal. */
  rascalPrice: 350,
  erBill: 250,
  startMoney: 60,

  /** Back Forty economy. */
  copperPerLb: [4, 6],
  catfishPrice: 15,
  shinePrice: 22,
  noodlesPerDay: 3,
  stillRunsPerDay: 2,
  cornholeGamesPerDay: 3,

  player: {
    radius: 0.38,
    walkSpeed: 4.2,
    sprintSpeed: 7.6,
    carrySpeedFactor: 0.85,
    pushSpeedFactor: 0.88,
    jumpVelocity: 5.2,
    gravity: 16,
  },
  car: {
    maxSpeed: 21,
    reverseSpeed: 6,
    accel: 9,
    brake: 18,
    drag: 0.6,
    steer: 1.9,
    radius: 1.15,
  },
  bounds: { minX: -110, maxX: 110, minZ: -112, maxZ: 112 },
  saveKey: 'double-wide-dreams/save/v1',
  settingsKey: 'double-wide-dreams/settings/v1',
} as const;
